export const isZoomScaleEqualsToOne = () => {
  return (
    window.visualViewport?.scale === 1 &&
    Math.round(
      (document.documentElement.clientWidth / window.innerWidth) * 100,
    ) /
      100 ===
      1
  );
};
